// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum CustomerCampaignLoginProp {
	CreationTime = 'creationTime',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy'
}

export type CustomerCampaignLoginPropCreationTime = {
	[CustomerCampaignLoginProp.CreationTime] : number | null
}
export type CustomerCampaignLoginPropId = {
	[CustomerCampaignLoginProp.Id] : number
}
export type CustomerCampaignLoginPropModificationTime = {
	[CustomerCampaignLoginProp.ModificationTime] : number | null
}
export type CustomerCampaignLoginPropModifiedBy = {
	[CustomerCampaignLoginProp.ModifiedBy] : models.UserDto
}


export type CustomerCampaignLogin = 
	CustomerCampaignLoginPropCreationTime & 
	CustomerCampaignLoginPropId & 
	CustomerCampaignLoginPropModificationTime & 
	CustomerCampaignLoginPropModifiedBy

export const CUSTOMER_CAMPAIGN_LOGIN_PROPERTY_NAMES = Object.freeze([CustomerCampaignLoginProp.CreationTime, CustomerCampaignLoginProp.Id, CustomerCampaignLoginProp.ModificationTime, CustomerCampaignLoginProp.ModifiedBy])

export type CustomerCampaignLoginDetails = 
	CustomerCampaignLoginPropId & 
	CustomerCampaignLoginPropCreationTime & 
	CustomerCampaignLoginPropModificationTime & 
	CustomerCampaignLoginPropModifiedBy

export const CUSTOMER_CAMPAIGN_LOGIN_DETAILS_PROPERTY_NAMES = Object.freeze([CustomerCampaignLoginProp.Id, CustomerCampaignLoginProp.CreationTime, CustomerCampaignLoginProp.ModificationTime, CustomerCampaignLoginProp.ModifiedBy])
